import React from 'react';
import { bool, func, number, object, shape, string } from 'prop-types';
import AgeRangeFilterPlain from './AgeRangeFilterPlain';
import AgeRangeFilterPopup from './AgeRangeFilterPopup';

const AgeRangeFilter = props => {
  const { showAsPopup, ...rest } = props;
  return showAsPopup ? (
    <AgeRangeFilterPopup {...rest} />
  ) : (
    <AgeRangeFilterPlain {...rest} />
  );
};

AgeRangeFilter.defaultProps = {
  rootClassName: null,
  className: null,
  initialValues: null,
  contentPlacementOffset: 0,
  liveEdit: false,
};

AgeRangeFilter.propTypes = {
  rootClassName: string,
  className: string,
  id: string.isRequired,
  label: string,
  queryParamNames: shape({
    0: string.isRequired,
  }).isRequired,
  onSubmit: func.isRequired,
  initialValues: object,
  contentPlacementOffset: number,
  showAsPopup: bool,
  liveEdit: bool,
};

export default AgeRangeFilter;

